// @ds/actions/CurrentEmployeeContext — minimal current-employee context owned
// by the design system. The app (`src/contexts/EmployeeContext.tsx`) keeps all
// data logic (Refine identity, supabase RPC, Sentry, Google scopes) and injects
// the ds subset value at the boundary via `CurrentEmployeeProvider`.
//
// The context object + `useCurrentEmployee` hook live in the sibling
// `@ds/actions/useCurrentEmployee` module.
import React from "react";
import {
  CurrentEmployeeContext,
  type CurrentEmployeeValue,
} from "@ds/actions/useCurrentEmployee";

export type { CurrentEmployeeValue } from "@ds/actions/useCurrentEmployee";

export const CurrentEmployeeProvider: React.FC<{
  value: CurrentEmployeeValue;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <CurrentEmployeeContext.Provider value={value}>
    {children}
  </CurrentEmployeeContext.Provider>
);
